import { createContext, useContext } from 'react';

const TutorialContext = createContext(null);
export const useTutorialContext = () => useContext(TutorialContext);
export default TutorialContext;
